import { StorageKey } from "core/appSettings";
import { createStore } from "core/store";

export const useConfigMode = createStore<boolean>({
  initialState: false,
  name: StorageKey.CONFIG_MODE,
});
